import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle
} from "reactstrap";

import FileInput from "react-simple-file-input";

import { deviceApi, setIdentityOnUserUpdate } from "../../identity/reducers/identitySlice"
import { selectUserById } from "../reducers/userSlice"
import { userApi } from "../reducers/userSlice"

import userPlaceholder from "../../../assets/images/users/ic_user.jpg";
import { useParams } from "react-router-dom";
import ProfileForm from "./components/ProfileForm";

export default () => {
  const { id } = useParams();
  const [showUploading, setShowUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [role, setRole] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [avatarMedia, setAvatarMedia] = useState(null);

  const dispatch = useDispatch();
  const me = useSelector((state) => state.userReducer.me);
  const user = useSelector((state) => selectUserById(state, id));

  useEffect(() => {
    if(id !== undefined) {
      if(user === undefined) {
        dispatch( userApi.fetchById({ uid: id }) )
      } else {
        initProfile(user);
        setShowUploading(false);
      }
    } else if(me === null) {
      dispatch(userApi.me({}));
    } else {
      initProfile(me);
      dispatch(setIdentityOnUserUpdate({
          firstname: me.first_name, 
          lastname: me.last_name, 
          email: me.email, 
          avatar: (me.avatar_media && me.avatar_media.resource) ? me.avatar_media.resource.thumb : null,
      }));
      setShowUploading(false);
    }
  }, [id, me, user, dispatch]);

  const initProfile = (user) => {
      if(user) {
        setRole(user.role !== null ? user.role : "");
        setFirstname(user.first_name !== null ? user.first_name : "");
        setLastname(user.last_name ? user.last_name : "");
        setAvatarMedia(user.avatar_media ? user.avatar_media : null);
      } else {
        console.log('USER is null');
      }
  }

  const onLoadAvatar = (event, file) => {
    console.log(file);

    dispatch(userApi.uploadAvatar({
        user: id === undefined ? me : user, 
        file: file
    }));
  }

  const updateProgress = (event) => {
    setUploadProgress((event.loaded / event.total) * 100);
  }

  const showUploadProgress = () => {
    setShowUploading(true);
  }

  return (
    <div>
      <Row>
        <Col xs="12" md="12" lg="4">
          <Card>
            <CardBody>
              <div className="text-center mt-4">
                <div className="text-center" style={ { position: "relative", textAlign: "center" } } >
                    <label>
                        <FileInput
                            readAs='binary'
                            style={ { display: 'none' } }

                            onLoadStart={showUploadProgress}
                            onLoad={onLoadAvatar}
                            onProgress={updateProgress}
                        />
                        <span className="avatar">
                            <img 
                                src={ ((avatarMedia && avatarMedia.resource) ? avatarMedia.resource.high : userPlaceholder) }
                                className="rounded-circle" width="150" alt="" style={ {cursor: "pointer"} } 
                            />
                        </span>
                    </label>

                    <div style={{
                          display: showUploading ? "block" : "none",
                          position: "absolute", 
                          top: 0, 
                          left: "50%", 
                          transform: "translate(-50%, 0%)", 
                          height: "150px", 
                          width: "150px", 
                          backgroundColor: "rgba(255,255,255,0.7)"
                      }} > 
                      <span style={{
                          position: "absolute", 
                          top: "55%", 
                          left: "50%", 
                          transform: "translate(-50%, -50%)",
                          color: "#555",
                          fontWeight: "bold",
                      }} >
                          uploading <br/> <h1> { uploadProgress }% </h1>
                      </span>
                    </div>
                </div>
                <CardTitle className="mt-2">{ firstname } { lastname }</CardTitle>
                <CardSubtitle>{role ? role.label : "NOT DEFINED"}</CardSubtitle>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xs="12" md="12" lg="8">
          <ProfileForm 
            showPasswordTab={id === undefined}
            btnProfileLabel="Update Profile"
            btnPasswordLabel="Update Setting"
            onSaveProfile={(data) => { dispatch(userApi.update(data)) }}
            onSavePassword={(data) => { dispatch(deviceApi.updatePassword(data)) }}
          />
        </Col>
      </Row>
    </div>
  );
};
